import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShoppingBag, Coffee } from 'lucide-react';
export function StepsSection() {
  const steps = [{
    num: '01',
    title: 'Lee Capítulo 1',
    desc: 'Identifica tu mercado local y entiende el ciclo.',
    icon: <BookOpen className="w-8 h-8" data-id="element-173" />
  }, {
    num: '02',
    title: 'Compra las 7 plantas',
    desc: 'Arma tu rueda de ciclo con ingredientes frescos.',
    icon: <ShoppingBag className="w-8 h-8" data-id="element-174" />
  }, {
    num: '03',
    title: 'Noche 1: Prepara tu té',
    desc: 'Usa el timer, sigue el protocolo y registra tu sueño.',
    icon: <Coffee className="w-8 h-8" data-id="element-175" />
  }];
  return <section className="py-14 md:py-24 px-4 bg-forest-800" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="text-center mb-10 md:mb-16" data-id="element-178">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-4" data-id="element-179">
            Empieza en 3 Pasos Simples
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-8 relative" data-id="element-180">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-forest-600 -z-10" data-id="element-181" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative bg-forest-700 p-5 md:p-8 rounded-xl border border-forest-500 text-center group hover:border-gold-500/50 transition-colors" data-id="element-182">
              <div className="w-16 h-16 md:w-24 md:h-24 mx-auto bg-forest-800 rounded-full border-4 border-forest-600 flex items-center justify-center text-gold-500 mb-4 md:mb-6 group-hover:scale-110 transition-transform shadow-xl" data-id="element-183">
                {step.icon}
              </div>
              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-3xl md:text-4xl font-serif font-bold text-forest-600 select-none" data-id="element-184">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-cream-100 mb-2" data-id="element-185">
                {step.title}
              </h3>
              <p className="text-cream-300" data-id="element-186">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}